import React, { Component } from 'react';
import { Grid } from '@material-ui/core';
import { graphql, createRefetchContainer, } from 'react-relay';
import generalLeaderboardSubscription from '../../data/subscription/generalLeaderboardSubscription';
import { withStyles } from '@material-ui/styles';
import useStyles from './styles';

class MMLeaderboardResult extends Component {
    constructor(props){
        super(props);
        this.state = {
            list: [],
            width: 0,
        }
        this.resizeWindow = this.resizeWindow.bind(this);
        window.addEventListener('resize', this.resizeWindow);
    }

    componentDidMount(){
        if(this.props.fetch_option){
            const { getLeaderboardPositions } = this.props;
            const data = getLeaderboardPositions.getLeaderboardPositions.data;
            this.setState({ list: data });

            const max_page = getLeaderboardPositions.getLeaderboardPositions.max_page;
            if(max_page) this.props.setMaxPage(max_page);
        }
        if(this.props.event_id){
            generalLeaderboardSubscription(
                { event_id: this.props.event_id },
                () => {
                    this._refetch();;
                }
            );
        }
        this.setState({ width: window.innerWidth });
    }

    componentWillReceiveProps(nextProps) {
        if (
            nextProps[this.props.fetch_option][this.props.fetch_option].code == 200 &&
            nextProps[this.props.fetch_option][this.props.fetch_option].data
        ) {
            this.setState({
                list: nextProps[this.props.fetch_option][this.props.fetch_option].data,
            });
        }
    }

    resizeWindow = () => {
        this.setState({ width: window.innerWidth });
    }

    _refetch = () => {
        this.props.relay.refetch(
            this.props.filter,
            null,
            () => { },
            { force: true },
        );
    };

    render(){
        const { classes, segment_id } = this.props;
        const { list, width } = this.state;
        const mobile = width < 600;
        const sliced = list.length > 2 && !mobile ? list.slice(0, Math.ceil(list.length / 2)) : list;

        return (
            <Grid container>
            {
                sliced.map((guest, i) => {
                    let winner = guest.guest.guest_title.split(",").includes(segment_id);
                    const next = mobile ? undefined : list[i + Math.ceil(list.length / 2)];
                    let jsx = [];
                    jsx.push(
                        <Grid item xs={12} sm={6} md={6} lg={6} className={classes.guestDiv} key={`guest-${i}`}>
                            <span className={classes.guestIndex}>
                                {guest.position}.
                            </span>
                            <span className={classes.guestName} style={winner ? { color: '#EE3124' } : {}}>
                                {guest.guest.guest_name.toUpperCase()}
                            </span>
                            <span className={classes.guestPoints}>
                                {guest.points} points
                            </span>
                        </Grid>
                    );
                    if(next && next.guest && !(i == 0 && list.length == 2)){
                        let winner = next.guest.guest_title.split(",").includes(segment_id);
                        jsx.push(
                            <Grid item xs={12} sm={6} md={6} lg={6} className={classes.guestDiv} key={`guest-${i + list.length / 2}`}>
                                <span className={classes.guestIndex}>
                                    {next.position}.
                                </span>
                                <span className={classes.guestName} style={winner ? { color: '#EE3124' } : {}}>
                                    {next.guest.guest_name.toUpperCase()}
                                </span>
                                <span className={classes.guestPoints}>
                                    {next.points} points
                                </span>
                            </Grid>
                        );
                    }
                    return jsx;
                })
            }
            </Grid>
        )
    }
}

export default createRefetchContainer(
    withStyles(useStyles)(MMLeaderboardResult),
    {
        getLeaderboardPositions: graphql`
            fragment MMLeaderboardResult_getLeaderboardPositions on Query
                @argumentDefinitions(
                    event_id: {
                        type: "Int!"
                    },
                    segment_id: {
                        type: "Int"
                    },
                    page_number: {
                        type: "Int"
                    },
                    rec_per_page: {
                        type: "Int"
                    },
                    searchInput: {
                        type: "String"
                    }
                ) {
                    getLeaderboardPositions(event_id: $event_id, segment_id: $segment_id, page_number: $page_number, rec_per_page: $rec_per_page, searchInput: $searchInput){
                        code
                        message
                        data {
                            points
                            position
                            guest {
                                guest_name
                                guest_title
                            }
                        }
                        max_page
                    }
                }
        `
    },
    graphql`
        query MMLeaderboardResultRefetchQuery($event_id: Int!, $segment_id: Int, $page_number: Int, $rec_per_page: Int, $searchInput: String){
            ...MMLeaderboardResult_getLeaderboardPositions
                @arguments(
                    event_id: $event_id
                    segment_id: $segment_id
                    page_number: $page_number
                    rec_per_page: $rec_per_page
                    searchInput: $searchInput
                )
        }
    `,
);